export default function({ intent, section, steamid }) {
    return {
        type: 'SET_LINK',
        intent, section, steamid
    }
}